/** Кнопка ui-kit: варианты оформления, занятость (`busy`) и необязательная подсказка ⓘ из реестра действий. */
import type { ButtonHTMLAttributes, ReactNode } from 'react'

import { ActionInfo } from './ActionInfo'
import { textOf } from './actionInfoContext'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** primary — главное действие экрана, ghost — действие в строке/шапке, danger — необратимое. */
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger'
  icon?: ReactNode
  /** Идёт операция: кнопка недоступна и объявляет это диктору (D-055). */
  busy?: boolean
  /**
   * Запись реестра действий (UI-ACTIONS): рядом рисуется ⓘ — что кнопка делает,
   * что изменит, кому доступна и как проверено. Без записи кнопка такая же, как была.
   */
  actionId?: string
  /** Почему кнопка сейчас выключена — словами экрана; ⓘ у выключенной кнопки активна и говорит это. */
  disabledReason?: string | null
}

/**
 * Кнопка. `busy` выключает её и объявляет занятость диктору; `actionId` добавляет ⓘ рядом, а у выключенной кнопки
 * подсказка остаётся активной и называет причину (`disabledReason`).
 */
export function Button({
  variant = 'secondary',
  icon,
  busy = false,
  disabled,
  children,
  type = 'button',
  actionId,
  disabledReason = null,
  ...rest
}: ButtonProps) {
  const off = disabled === true || busy
  const button = (
    <button
      {...rest}
      type={type}
      className="krp-button"
      data-variant={variant}
      disabled={off}
      aria-busy={busy || undefined}
    >
      {icon}
      {children}
    </button>
  )
  if (actionId === undefined) return button
  const label = rest['aria-label'] ?? textOf(children)
  return (
    <ActionInfo
      id={actionId}
      {...(label !== undefined ? { label } : {})}
      disabled={off}
      disabledReason={busy && disabledReason === null ? 'Команда выполняется — дождитесь ответа.' : disabledReason}
    >
      {button}
    </ActionInfo>
  )
}
